export default __webpack_public_path__ + "6841b675ef00921394cf385bd16391ba.svg";